'use strict';

import React from "react";
import PropTypes from "prop-types";

import PlanItemCourse from "./PlanItemCourse";
import PlanItemPlaceholder from "./PlanItemPlaceholder";
import {PlanViewType} from "../lib/Constants";

/**
 * Component for displaying a plan item, switches based on whether item is a course or placeholder
 */
function PlanItem(props) {
    let component;

    // is plan item a course or a placeholder
    if ( props.item.placeHolder ) {
        component = <PlanItemPlaceholder {...props} />
    } else {
        component = <PlanItemCourse {...props} />
    }

    return component;
}

PlanItem.propTypes = {
    item: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    openForPlanning: PropTypes.bool.isRequired,
    viewType: PropTypes.oneOf(Object.keys(PlanViewType)).isRequired
};

export default PlanItem;